// import React, { useState, useEffect } from 'react';
// import './Gallery.css';
// import Navbar from '../Home/Navbar';
// import Footer from '../Home/Footer';

// const Galleryy = () => {
//   const [galleryData, setGalleryData] = useState([]);

//   useEffect(() => {
//     // Fetch gallery data from API
//     fetch('https://api.garudasena.org/api/gallery')
//       .then(response => response.json())
//       .then(data => setGalleryData(data))
//       .catch(error => console.error('Error fetching gallery data:', error));
//   }, []);

//   // Group images by image_text
//   const groupedImages = galleryData.reduce((groups, image) => {
//     if (!groups[image.image_text]) {
//       groups[image.image_text] = [];
//     }
//     groups[image.image_text].push(image);
//     return groups;
//   }, {});

//   return (
//         <>
//       <Navbar />
//     <div className="gallery-container">
//       {Object.entries(groupedImages).map(([sectionTitle, sectionImages]) => (
//         <div key={sectionTitle} className="gallery-section">
//           <h2 className="section-title">{sectionTitle}</h2>
//           <div className="gallery-images">
//             {sectionImages.map(image => (
//               <div key={image.id} className="image-item">
//                 <img
//                   src={image.image}
//                   alt={image.image_text}
//                   className="gallery-image"
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       ))}
//     </div>

//          <Footer/>
//         </>
//   );
// };

// export default Galleryy;

import React, { useState, useEffect } from 'react';
import './Gallery.css';
import Navbar from '../Home/Navbar';
import Footer from '../Home/Footer';

const Galleryy = () => {
  const [galleryData, setGalleryData] = useState([]);

  useEffect(() => {
    // Fetch gallery data from API
    fetch('https://api.garudasena.org/api/gallery')
      .then(response => response.json())
      .then(data => setGalleryData(data))
      .catch(error => console.error('Error fetching gallery data:', error));
  }, []);

  // Group images by image_text
  const groupedImages = galleryData.reduce((groups, image) => {
    if (!groups[image.image_text]) {
      groups[image.image_text] = [];
    }
    groups[image.image_text].push(image);
    return groups;
  }, {});

  return (
    <>
      <Navbar />
      <div className="gallery-container1">
        {Object.entries(groupedImages).map(([sectionTitle, sectionImages]) => (
          <div key={sectionTitle} className="gallery-section1">
            <h2 className="section-title1">{sectionTitle}</h2>
            <div className="gallery-images1">
              {sectionImages.map(image => (
                <div key={image.id} className="image-item1">
                  <img
                    src={image.image}
                    alt={image.image_text}
                    className="gallery-image1"
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      <Footer />
    </>
  );
};

export default Galleryy;
